import { render, staticRenderFns } from "./openTimeLevelRewardRecord.vue?vue&type=template&id=64d712dc&scoped=true"
import script from "./openTimeLevelRewardRecord.vue?vue&type=script&lang=ts"
export * from "./openTimeLevelRewardRecord.vue?vue&type=script&lang=ts"
import style0 from "./openTimeLevelRewardRecord.vue?vue&type=style&index=0&id=64d712dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d712dc",
  null
  
)

export default component.exports